export default "__VITE_ASSET__fe7e6a8b__"